
// Get all elements with the 'text' class
var elements = document.getElementsByClassName("text-overlap");

// Loop through each element and truncate the text if it exceeds a certain height
for (var i = 0; i < elements.length; i++) {
 var element = elements[i];
 var lineHeight = parseFloat(getComputedStyle(element).lineHeight);
 var maxHeight = 1 * lineHeight; // Set the maximum height in pixels (e.g., 2 lines)

 // while (element.clientHeight > maxHeight) {
 //    element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
 // }
}